//  openModal
export const COMMON_OPEN_MODAL = 'COMMON_OPEN_MODAL';
export const COMMON_CLOSE_MODAL = 'COMMON_CLOSE_MODAL';
//  setAccount
export const COMMON_SET_ACCOUNT = 'COMMON_SET_ACCOUNT';